import React from 'react';
import { cn } from '../../lib/utils';

export const ToggleSwitch = ({ checked, onChange, label, disabled = false, activeColor = 'bg-[#00d9ff]' }: { checked: boolean, onChange: (c: boolean) => void, label?: React.ReactNode, disabled?: boolean, activeColor?: string }) => (
  <div className="flex items-center justify-between w-full">
    {label && <div className="text-[9px] uppercase tracking-[1px] text-[#666666] font-bold">{label}</div>}
    <button
      type="button"
      disabled={disabled}
      onClick={(e) => { e.stopPropagation(); onChange(!checked); }}
      className={cn(
        "relative inline-flex h-4 w-8 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none shadow-inner",
        checked ? activeColor : "bg-[#111]",
        disabled ? "opacity-50 cursor-not-allowed" : ""
      )}
    >
      <span
        className={cn(
          "pointer-events-none inline-block h-3 w-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
          checked ? "translate-x-4" : "translate-x-0"
        )}
      />
    </button>
  </div>
);
